module.exports = __webpack_public_path__ + "static/media/yuanzuishanicon.b0d1ae06.webp";